(function () {
  'use strict';

  angular.module('wsLrs.controllers').controller('VerbAliasesCtrl', ['$scope', '$controller', '$http', '$timeout', '$uibModal', 'Api', function ($scope, $controller, $http, $timeout, $uibModal, Api) {
    $scope.defaultSortBy = "display";
    $scope.sortControls = [{
      "title": "Verb",
      "options": {
        "Ascending": "display",
        "Descending": "-display"
      }
    }, {
      "title": "Aliases",
      "options": {
        "Ascending": "aliasCount",
        "Descending": "-aliasCount"
      }
    }];
    $scope.downloadUrl = Api.url("/acc/verbs/aliases/csv");
    $scope.apiUrl = Api.url("/acc/verbs/aliases");
    $scope.uiConfig = {
      hideDownloadUrl: true
    };
    function fetchAliases() {
      return $http.get($scope.apiUrl, {
        "_limit": 1,
        "_offset": 0
      });
    }
    function ifAliasesExist(f, g) {
      return fetchAliases().then(function (_ref) {
        var count = _ref.data.count;
        return count > 0 ? f() : g();
      });
    }
    var onlyWhenAliasesExist = function onlyWhenAliasesExist(f) {
      return ifAliasesExist(f, function () {
        return undefined;
      });
    };
    var hideDownloadUrl = $scope.$safeApply.bind($scope, function () {
      $scope.uiConfig.hideDownloadUrl = true;
    });
    var showDownloadUrl = $scope.$safeApply.bind($scope, function () {
      $scope.uiConfig.hideDownloadUrl = false;
    });
    var handleVerbEdit = _.debounce($scope.$safeApply.bind($scope, function () {
      ifAliasesExist(showDownloadUrl, hideDownloadUrl);
    }), 500);
    onlyWhenAliasesExist(showDownloadUrl);
    $scope.$on('verb-edited', handleVerbEdit);
    $scope.formatSearchSuggestion = function formatSearchSuggestion(result) {
      return result.display;
    };
    $scope.processFetchResponse = function (response) {
      return response.data;
    };
    $scope.defaultSearchBy = "searchTerm";
    $scope.searchPlaceholder = "Search for an alias";
    $scope.editDisplay = function editDisplay(_aliasTarget) {
      /* ToDo: Remove jshint and console.log */
      /* jshint node: true */
      var modal = $uibModal.open({
        controller: "VerbDisplayEditModalCtrl",
        templateUrl: 'modules/app/data/verbs/aliases/display-edit-modal.html',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          aliasTarget: function aliasTarget() {
            return _aliasTarget;
          }
        }
      });
      console.log("Now waiting for modal to close ....");
      modal.closed.then(function () {
        console.log("After the modal has closed ....");
        console.log(JSON.stringify($scope.aliasTarget));
        $scope.fetch();
        console.log(JSON.stringify($scope.aliasTarget));
      });
    };
    $scope.editAlias = function editAlias(_aliasTarget2) {
      var modal = $uibModal.open({
        controller: "VerbAliasEditModalCtrl",
        templateUrl: 'modules/app/data/verbs/aliases/alias-edit-modal.html',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          aliasTarget: function aliasTarget() {
            return _aliasTarget2;
          }
        }
      });
      modal.closed.then(function () {
        $scope.fetch();
      });
    };
    $scope.addAliases = function addAliases() {
      $scope.editAlias(null);
    };
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
  }]).controller('VerbAliasEditModalCtrl', ['$scope', '$controller', '$http', '$timeout', '$uibModalInstance', 'Api', 'Logger', 'Utils', 'aliasTarget', '$rootScope', function ($scope, $controller, $http, $timeout, $uibModalInstance, Api, Logger, Utils, aliasTarget, $rootScope) {
    var aliasEndpoint = Api.url("/acc/verbs/aliases");
    $scope.close = function () {
      $uibModalInstance.dismiss();
    };
    $scope.aliasTarget = aliasTarget;
    if (aliasTarget) {
      $scope.apiUrl = Api.url("/acc/verbs?aliasId=" + aliasTarget.verbId);
    } else {
      // Setup verb selector to choose aliasTarget
      $scope.selectedVerb = null;
      $scope.$watch("selectedAliasTarget", function (newValue) {
        if (newValue) {
          $scope.aliasTarget = newValue;
          $scope.apiUrl = Api.url("/acc/verbs?aliasId=" + newValue.verbId);
          $scope.clearSelectedAliasSource();
          $scope.resetPage();
        }
      });
    }
    $scope.addAlias = function addAlias() {
      $scope.adding = true;
    };
    $scope.$watch("selectedAliasSource", function (aliasSource) {
      if (!aliasSource) {
        return;
      }
      $scope.clearSelectedAliasSource();
      $scope.successMessage = null;
      $scope.errorMessage = null;
      var aliasRule = {
        from: aliasSource.verbId,
        to: $scope.aliasTarget.verbId
      };
      $http.post(aliasEndpoint, aliasRule).then(function success() {
        $scope.$broadcast('item-added', aliasSource);
        $scope.adding = false;
        $scope.successMessage = "A new alias for '" + $scope.aliasTarget.display + "' has been created. " + "Please allow up to 30 minutes before this change is reflected in Watershed.";
      }, function error(response) {
        if (response && response.data) {
          $scope.errorMessage = response.data.message;
        }
      });
    });
    $scope.finishEditing = function finishEditing() {
      $rootScope.$broadcast('verb-edited');
      try {
        $scope.$dismiss('cancel');
      } catch (e) {
        Logger.warn(e);
      }
    };
    $scope.removeAlias = function removeAlias(fromAlias, index) {
      $scope.successMessage = null;
      $scope.errorMessage = null;
      var aliasRule = {
        from: fromAlias.verbId,
        to: null
      };
      $http.post(aliasEndpoint, aliasRule).then(function success() {
        $scope.$broadcast('item-delete', index);
        $scope.successMessage = "The chosen alias for '" + $scope.aliasTarget.display + "' has been removed. " + "Please allow up to 30 minutes before this change is reflected in Watershed.";
      }, function error(response) {
        if (response && response.data) {
          $scope.errorMessage = response.data.message;
        }
      });
    };
    $scope.formatSearchSuggestion = function formatSearchSuggestion(result) {
      return result.display;
    };
    $scope.processFetchResponse = function (response) {
      return response.data;
    };
    $scope.defaultSearchBy = "display";
    $scope.searchPlaceholder = "Search for an alias";
    $scope.defaultSortBy = "display";
    $scope.sortControls = [{
      "title": "Verb",
      "options": {
        "Ascending": "display",
        "Descending": "-display"
      }
    }, {
      "title": "Alias Created",
      "options": {
        "Ascending": "updated",
        "Descending": "-updated"
      }
    }];
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
  }]);
})();
